import React, { useState, useContext, useEffect } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import errorMessages, { generalErrorMessage, leadGenErrorMessage } from "../config/errorMessages"
import errorMessagesBM, { generalErrorMessageBM, leadGenErrorMessageBM } from "../config/errorMessagesBM"
// import { useForm } from "react-hook-form";
import axios from "axios";
import { AppContext } from "../contexts"
import Select from "react-select"
import options from "../config/occupation"
import typeOfBizOptions from "../config/typeOfBusiness"

const ErrorDialog = ({ isOpen, toggle, message, responseData, type, lang }) => {
  const state = useContext(AppContext)
  const getErrorMessage = lang.id === 'EN' ? errorMessages.find((errorMessage) => errorMessage.apiError === message)?.message : errorMessagesBM.find((errorMessage) => errorMessage.apiError === message)?.message

  const displayGeneralErrorMsg = lang.id === 'EN' ? generalErrorMessage : generalErrorMessageBM

  const displayLeadGenErrorMsg = lang.id === 'EN' ? leadGenErrorMessage : leadGenErrorMessageBM

  const [correspondenceAddress, setCorrespondenceAddress] = useState(false)
  const [contactNumber, setContactNumber] = useState()
  const [occupation, setOccupation] = useState(responseData?.occpCode || "")
  const [marital, setMarital] = useState(responseData?.marital || "")
  const [typeOfBusiness, setTypeOfBusiness] = useState(responseData?.typeOfBusiness || "")
  const [isSubmitting, setIsSubmitting] = useState(false)

  let codeHtml = "";

  const isLeadGenForm = message !== undefined && typeof message === "string" &&
    (
      (message.indexOf("Referred") > -1) || (message.indexOf("Decline") > -1)
    );

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
      lineHeight: 1.2,
      color: state.isSelected ? 'white' : '#5F5456',
      backgroundColor: state.isSelected ? '#CC0022' : 'white'
    }),
    control: (provided, state) => {
      // none of react-select's styles are passed to <Control />
      const cstyle = {
        paddingTop: 12,
        border: 'none',
        paddingLeft: 5
      }
      return { ...provided, ...cstyle };
    },
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    }
  }

  const maritalStates = [
    { label: lang.maritalstatus.MARRIED, value: "M" },
    { label: lang.maritalstatus.SINGLE, value: "S" },
    { label: lang.maritalstatus.DIVORCED, value: "D" },
    { label: lang.maritalstatus.WIDOWED, value: "W" },
    { label: lang.maritalstatus.OTHERS, value: "O" },
  ];

  const Results = () => (
    <div className="mt-3 mb-3 text-left">
      <font color='black'>{lang.errors.msg}</font>
    </div>
  )

  const normalizeAddress = (e) => {
    state.setCorAddress(false)
    const { value } = e.target
    setCorrespondenceAddress(value)
  }

  const normalizeContact = (e) => {
    state.setContactNo(false)
    let value = e.target.value
    value = value.replace(/[^0-9]+/g, "")
    setContactNumber(value)
  }

  const handleOccupation = selectedOccupation => {
    state.setOccp(false)
    setOccupation(selectedOccupation.value)
  }

  const handleMarital = (selectedMarital) => {
    setMarital(selectedMarital.value);
  };

  const handleTypeOfBiz = selectedTypeOfBiz => {
    setTypeOfBusiness(selectedTypeOfBiz.value)
  }

  const CorrErrMsg = () => (
    <font color='red'>{lang.simplequote.field_require}</font>
  )

  useEffect(() => {
    if (responseData?.occpCode) {
      setOccupation(responseData?.occpCode);
    }
  }, [responseData?.occpCode]);

  useEffect(() => {
    if (responseData?.marital) {
      setMarital(responseData?.marital);
    }
  }, [responseData?.marital]);

  useEffect(() => {
    if (responseData?.typeOfBusiness) {
      setTypeOfBusiness(responseData?.typeOfBusiness);
    }
  }, [responseData?.typeOfBusiness]);

  if (isLeadGenForm) {
    //type=P, B.
    if (type === 'P') {
      codeHtml =
        <div className="row">
          {/* <div className="col-12 mb-3 text-center" style={{ fontSize: "17px" }}>
            {lang.errors.requestManual}
          </div> */}
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                type="text"
                name="registrationNo"
                // placeholder={lang.vehPlateNo}
                placeholder="Vehicle Plate Number"
                className="floating__input disable"
                readOnly={true}
                value={responseData.registrationNo}
                maxLength={15}
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.vehRegNo} /> */}
              <label htmlFor="input__username" className="floating__label" data-content={lang.errors.vehicleRegistrationNo} />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input disable"
                type="text"
                name="nricPassport"
                // placeholder={lang.nricPassport}
                placeholder="NRIC No./Passport"
                maxLength={14}
                readOnly={true}
                value={responseData.nricPassport}
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.nricPassport} /> */}
              <label htmlFor="input__username" className="floating__label" data-content={lang.errors.nricPassport} />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input disable"
                type="text"
                name="email"
                // placeholder={lang.email}
                placeholder="Email"
                maxLength={60}
                readOnly={true}
                value={responseData.email}
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.email} /> */}
              <label htmlFor="input__username" className="floating__label" data-content={lang.errors.email} />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input disable"
                type="text"
                name="name"
                maxLength={60}
                placeholder="Full Name"
                readOnly={true}
                value={responseData.name}
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.fullName} /> */}
              <label htmlFor="input__username" className="floating__label" data-content={lang.errors.fullName} />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input disable"
                type="text"
                name="postcode"
                placeholder="Postcode"
                value={responseData.postcode}
              />
              <label
                htmlFor="input__username"
                className="floating__label"
                data-content={lang.simplequote.postcode}
              />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <div className="select">
                <Select
                  styles={customStyles}
                  className="floating__input3"
                  options={maritalStates}
                  placeholder={lang.simplequote.dropdown_selection}
                  value={maritalStates.find(
                    (a) => a.value === marital,
                  )}
                  onChange={handleMarital}
                />
                <label className="floating-label">
                  {lang.simplequote.marital_status}
                </label>
              </div>
            </div>
          </div>
          {/* <div className="col-md-12 mb-2">
            <div className="floating">
              <input
                className="floating__input"
                type="text"
                name="Correspondence_Address"
                // placeholder={lang.address}
                placeholder="Address"
                maxLength={180}
                onChange={(e) => normalizeAddress(e)}
              />
              <label htmlFor="input__username" className="floating__label" data-content={lang.errors.CorrAddress} />
            </div>
            {state.corAddress ? <CorrErrMsg /> : null}
          </div> */}
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input"
                type="tel"
                name="Contact_Number"
                value={contactNumber}
                // placeholder={lang.contactNo}
                placeholder="Contact Number"
                maxLength={20}
                onChange={(e) => normalizeContact(e)}
                inputmode="numeric"
                pattern="[0-9]*"
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.contactNo} /> */}
              <label htmlFor="input__username" className="floating__label" data-content={lang.errors.contactNo} />
            </div>
            {state.contactNo ? <CorrErrMsg /> : null}
          </div>
          <div className="col-md-6 mb-2">
            <div className="select">
              <div className="floating">
                <Select
                  className="floating__input3"
                  value={options.find(obj => obj.value === occupation)}
                  onChange={handleOccupation}
                  options={options}
                  // placeholder={lang.form.pleaseSelect}
                  placeholder={lang.selection}
                  styles={customStyles}
                />
                {/* <label className="floating-label">{lang.form.occupation}</label> */}
                <label className="floating-label">{lang.errors.occupation}</label>
                <input type="hidden" name="occupation*" />
              </div>
            </div>
            {state.occp ? <CorrErrMsg /> : null}
          </div>
          <div className={`col-md-4 offset-md-4`}>
            <div className="button-box mt-3 mb-3">
              <button type="submit" onClick={(e) => onSubmitClick(e)} className="btn btn-sompo_primary red" disabled={isSubmitting}>{lang.errors.submit}</button>
            </div>
          </div>
        </div>
    } else if (type === 'B') {
      codeHtml =
        <div className="row">
          {/* <div className="col-12 mb-3 text-center" style={{ fontSize: "17px" }}>
            {lang.errors.requestManual}
          </div> */}
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                type="text"
                name="registrationNo"
                //placeholder={lang.vehPlateNo}
                placeholder="Vehicle Plate Number"
                className="floating__input disable"
                readOnly={true}
                value={responseData.registrationNo}
                maxLength={15}
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.vehRegNo}/> */}
              <label htmlFor="input__username" className="floating__label" data-content="Vehicle Registration No." />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input disable"
                type="text"
                name="bizRegNo"
                // placeholder={lang.form.busRegNo}
                placeholder="Business Registration No."
                maxLength={20}
                readOnly={true}
                value={responseData.bizRegNo}
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.form.busRegNo} /> */}
              <label htmlFor="input__username" className="floating__label" data-content="Business Registration No." />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input disable"
                type="text"
                name="email"
                //placeholder={lang.email}
                placeholder="Email"
                maxLength={60}
                readOnly={true}
                value={responseData.email}
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.email} /> */}
              <label htmlFor="input__username" className="floating__label" data-content="Email" />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input disable"
                type="text"
                name="name"
                maxLength={60}
                // placeholder={lang.companyName}
                placeholder="Company Name"
                readOnly={true}
                value={responseData.name}
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.companyName} /> */}
              <label htmlFor="input__username" className="floating__label" data-content="Company Name*" />
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input disable"
                type="text"
                name="postcode"
                placeholder="Postcode"
                value={responseData.postcode}
              />
              <label
                htmlFor="input__username"
                className="floating__label"
                data-content={lang.simplequote.postcode}
              />
            </div>
          </div>
          {/* <div className="col-md-12 mb-2">
            <div className="floating">
              <input
                className="floating__input"
                type="text"
                name="Correspondence_Address"
                // placeholder={lang.address}
                placeholder="Address"
                maxLength={180}
                onChange={(e) => normalizeAddress(e)}
              />
              <label htmlFor="input__username" className="floating__label" data-content="Correspondence Address*" />
            </div>
            {state.corAddress ? <CorrErrMsg /> : null}
          </div> */}
          <div className="col-md-6 mb-2">
            <div className="floating">
              <input
                className="floating__input"
                type="tel"
                name="Contact_Number"
                //placeholder={lang.contactNo}
                placeholder="Contact Number"
                value={contactNumber}
                maxLength={20}
                onChange={(e) => normalizeContact(e)}
                inputmode="numeric"
                pattern="[0-9]*"
              />
              {/* <label htmlFor="input__username" className="floating__label" data-content={lang.contactNo} /> */}
              <label htmlFor="input__username" className="floating__label" data-content="Contact Number*" />
            </div>
            {state.contactNo ? <CorrErrMsg /> : null}
          </div>
          <div className="col-md-6 mb-2">
            <div className="select">
              <div className="floating">
                <Select className="floating__input3" value={typeOfBizOptions.find(obj => obj.value === typeOfBusiness)}
                  onChange={handleTypeOfBiz}
                  options={typeOfBizOptions}
                  // placeholder={lang.form.pleaseSelect}
                  placeholder="Please Select"
                  styles={customStyles}
                />
                {/* <label className="floating-label">{lang.form.typeOfBusiness}</label> */}
                <label className="floating-label">Type of Business</label>
                <input type="hidden" name="typeOfBusiness" />
              </div>
            </div>
          </div>
          <div className={`col-md-4 offset-md-4`}>
            <div className="button-box mt-3 mb-3">
              <button type="submit" onClick={(e) => onSubmitClick(e)} className="btn btn-sompo_primary red" disabled={isSubmitting}>{lang.errors.submit}</button>
            </div>
          </div>
        </div>
    }
  }

  const onSubmitClick = (e) => {
    setIsSubmitting(true);

    let hasError = false;

    if (!contactNumber) {
      state.setContactNo(true)
      hasError = true;
    }

    if (type === 'P' && !occupation) {
      state.setOccp(true)
      hasError = true;
    }

    // if (!correspondenceAddress || correspondenceAddress === undefined || correspondenceAddress === '') {
    //   state.setCorAddress(true)
    //   return
    // }

    if (hasError) {
      setIsSubmitting(false)
      return;
    }

    let emailData = {};

    if (type === "P") {
      const occupationLabel =
        options.find((obj) => obj.value === occupation)?.label || occupation;

      const maritalLabel = maritalStates.find((obj) => obj.value === marital)?.label || marital;

      emailData = {
        errorMsg: message,
        type: type,
        email: responseData.email,
        vehicleNumber: responseData.registrationNo,
        nricPassport: responseData.nricPassport,
        name: responseData.name,
        postcode: responseData.postcode,
        // correspondenceAddress: correspondenceAddress,
        contactNumber: contactNumber,
        occupation: occupationLabel,
        marital: maritalLabel
      };
    } else if (type === "B") {
      const typeOfBusinessLabel =
        typeOfBizOptions.find((obj) => obj.value === typeOfBusiness)?.label ||
        typeOfBusiness;

      emailData = {
        errorMsg: message,
        type: type,
        email: responseData.email,
        vehicleNumber: responseData.registrationNo,
        bizRegNo: responseData.bizRegNo,
        name: responseData.name,
        postcode: responseData.postcode,
        // correspondenceAddress: correspondenceAddress,
        contactNumber: contactNumber,
        typeOfBusiness: typeOfBusinessLabel,
      };
    }

    axios
      .post("/quote/general/customer-service", {
        subject: "securemotor-quote",
        ...emailData,
      })
      .then(function (response) {
        if (response?.data?.status == "Success") {
          state.setShowResults(true);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const toggleLeadGen = () => {
    toggle();
  };

  // temporary quick solution
  let isQuoteLimit =
    getErrorMessage !== undefined &&
    typeof getErrorMessage === "string" &&
    getErrorMessage.indexOf("REQUEST LIMIT EXCEEDED") > -1;

  if (isQuoteLimit) {
    codeHtml = (
      lang.id === 'EN' ? <p>You have reached the maximum number of quote requests allowed for today. Please try again tomorrow. Alternatively, you may email <a href="mailto:banca.support@bsompo.com.my">banca.support@bsompo.com.my</a> for further assistance.</p>
        : <p>Anda telah mencapai jumlah maksimum permintaan sebut harga yang dibenarkan untuk hari ini. Sila cuba semula esok. Sebagai alternatif, anda boleh menghantar e-mel ke <a href="mailto:banca.support@bsompo.com.my">banca.support@bsompo.com.my</a> untuk bantuan lanjut.
        </p>
    );
  }

  useEffect(() => {
    if (isOpen) {
      setIsSubmitting(false);
      state.setShowResults(false);
    }
  }, [isOpen]);

  return <>
    {isLeadGenForm ?
      <Modal isOpen={isOpen} toggle={toggleLeadGen} className="contact">
        <ModalHeader className="border-0" toggle={toggleLeadGen}>
          {/* {lang.errors.errorOccured}! */}
        </ModalHeader>
        <ModalBody className="py-4">
          {state.showResults &&
            <div className="col-12 mb-3 text-center" style={{ fontSize: "20px" }}>
              {lang.errors.successRequest}
            </div>
          }

          {state.showResults ?
            <div className="mt-3 mb-3 text-center">
              <font color='black'>
                <p style={{ fontSize: "16px" }}>
                  {lang.errors.msgEv1a} <strong>{lang.errors.msgEv1b}</strong>.{" "}
                  {lang.errors.msgEv2}{" "}
                  {/* <a href={`mailto:${lang.errors.cxEmail}`}><strong>{lang.errors.cxEmail}</strong></a>. */}
                  {lang.errors.msgEv3}
                </p>
              </font>
            </div> :
            <>
              <div className="col-md-12 text-center mb-4" style={{ fontSize: "17px" }}>
                {getErrorMessage || displayLeadGenErrorMsg}
              </div>
              <div className="col-md-12">
                {codeHtml}
              </div>
            </>}
        </ModalBody>
        {/* <ModalFooter>
      <Button onClick={() => toggle()}>Ok</Button>
    </ModalFooter> */}
      </Modal>
      :
      <Modal isOpen={isOpen} toggle={toggle} className="contact">
        <ModalHeader className="border-0" toggle={toggle}>
          {/* {lang.errors.errorOccured} */}
        </ModalHeader>
        <ModalBody className="py-4">
          {isQuoteLimit ? codeHtml : (getErrorMessage || displayGeneralErrorMsg)}
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => toggle()}>Ok</Button>
        </ModalFooter>
      </Modal>
    }
  </>
}

export default ErrorDialog